import React, {useCallback} from 'react'
import '../../assets/css/pop.scss';

import { Checkbox,Radio } from 'pretty-checkbox-react';
import InputMask from 'react-input-mask';
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft, faPencil, faTimes, faTrash, faUsers} from "@fortawesome/pro-regular-svg-icons";
import Actions from "../../helpers/actions";
import Functions from "../../helpers/functions";
import Select from "react-select";
import 'react-tabs/style/react-tabs.css';
import Stepper from "react-stepper-horizontal";
import Avatar from "react-avatar";
import {AreaSeries, HighchartsSparkline, Tooltip} from "react-jsx-highcharts";
import Switch from "react-ios-switch/lib";
import ContentLoader from "react-content-loader";


const selectStyle = {
    option: (provided, state) => ({
        ...provided,
    }),
    control: (provided, state) => ({
        ...provided,
        position:'relative',
        zIndex:1005
    }),
}


export default class assignToUser extends React.Component {
    constructor(props) {
        super(props);

        this.defaultVars = {
            data:props.data,
            users:[]
        };

        this.state = this.defaultVars;
    }
    componentDidMount(){
        this.getData();
    }
    async getData(){
        this.setState({loading:true});
        try {
            var url = Functions.generateURI(
                "/customers/get",
                {id:this.state.data.id}
            );

            var customer = await fetch(url.address, url.header);
            customer = await customer.json();


            var url2 = Functions.generateURI(
                "/users/getAll",
                {}
            );

            var response = await fetch(url2.address, url2.header);
            response = await response.json();

            if(response.status){
                var users = [];
                response.data.forEach((user)=>{
                    var addUser = {id:user.id,firstName:user.firstName,lastName:user.lastName,title:user.title,assigned:false};
                    customer.data.respUsers.forEach((assignedUsers)=>{
                        if(assignedUsers.user.id == addUser.id){
                            addUser.assigned = true;
                        }
                    });
                    users.push(addUser);
                });
                this.setState({users:users});
            } else {

            }
        } catch(error) {

        }
    }
    async toggleUser(checked,user,key){
        var newData = this.state.users;
        newData[key].assigned = checked;
        this.setState({users:newData});

        var url = Functions.generateURI("/customers/assignUser",{
            userID:user.id,
            customerID:this.state.data.id,
            action:(checked?"add":"remove")
        });

        var response = await fetch(url.address, url.header);
        response = await response.json();

        if(response.status){

        } else {

        }


    }
    render(){

        return (
            <div id={"popForm"} className={"assignToUser"}>
                <span className={"close"} onClick={()=>{
                    // eslint-disable-next-line no-restricted-globals
                    var r = confirm("Are you sure to close ?");
                    if (r == true) {
                        this.props.closePopUp();
                        Actions.emit("closeSidePanel");
                    }
                }}><FontAwesomeIcon  icon={faTimes} size="lg"/></span>
                <div className={"row"}>
                    <div className={"columns small-12"}>
                        <ul className={"list"}>
                            {this.renderUserList()}
                        </ul>
                        <a className={"button full"} onClick={()=>{
                            this.props.closePopUp();
                        }}>CLOSE</a>
                    </div>
                </div>
            </div>
        );
    }
    renderUserList(){
        if(this.state.users.length > 0){
            return this.state.users.map((user,key)=>{
                return(
                    <li className={"row align-middle user"} key={"u_"+key}>
                        <div className={"columns name shrink"}>
                            <div className={"title"}>
                                <div className={"row collapse"}>
                                    <div className={"columns"}>
                                        <a onClick={()=>{
                                            this.props.openSidePanel("users",3)
                                        }}><b>{user.firstName+" "+user.lastName}</b></a>
                                        <small>{user.title}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={"columns"}>
                            <div className={"row align-right"}>
                                <div className={"columns shrink"}>
                                    <Switch
                                        checked={user.assigned}
                                        className={"switch small"}
                                        handleColor="white"
                                        offColor="white"
                                        onChange={(checked) => {
                                            this.toggleUser(checked,user,key);
                                        }}
                                        onColor="rgb(102, 170, 234)"
                                    />
                                </div>
                            </div>
                        </div>
                    </li>
                );
            });
        } else {
            var shimmers = [{},{},{},{},{},{},{},{},{},{}];
            return shimmers.map((data,i)=>{
                return(
                    <li className={"row shimmer"} key={"u_"+i}>
                        <div className={"columns small-12"}>
                            <ContentLoader
                                width={620}
                                height={50}
                            >
                                <rect x="0" y="0" rx="25" ry="25" width="50" height="50" />
                                <rect x="60" y="7" rx="4" ry="4" width="240" height="16" />
                                <rect x="60" y="30" rx="4" ry="4" width="240" height="10" />
                                <rect x="350" y="7" rx="4" ry="4" width="300" height="16" />
                                <rect x="350" y="30" rx="4" ry="4" width="300" height="10" />
                            </ContentLoader>
                        </div>
                    </li>
                );
            })
        }
    }
}

